import {observable, action, runInAction} from 'mobx';
import Api from '../../services/api';
import {IUiContent} from "../../types/IUiContent";

class UiContentsStore {
    constructor() {
        this.getDefaultContents();
    }

    @observable public uiContents:IUiContent[] = [];

    @action
    public getDefaultContents = async () => {
        try {
            const uiContents = await Api.getDefaultContents();
            runInAction(() => {
                this.uiContents = uiContents;
            });
        } catch(e) {
            console.log(e);
        }
    };

}

const uiContentsStore = new UiContentsStore();

export default uiContentsStore;
